export default [
	{
		path: '/schedule',
		name: 'schedule',
		component: () => import(/* webpackChunkName: "Schedule" */ '@/views/schedule/Index.vue'),
		meta: {
			title: 'Geplande opnames',
			requiresAuth: true,
		}
	},
	{
		path: '/schedule/doing',
		name: 'scheduleDoing',
		component: () => import(/* webpackChunkName: "ScheduleDoing" */ '@/views/schedule/Doing.vue'),
		meta: {
			title: 'Lopende opnames',
			requiresAuth: true,
		}
	},
	{
		path: '/schedule/finished',
		name: 'scheduleFinished',
		component: () => import(/* webpackChunkName: "ScheduleFinished" */ '@/views/schedule/Finished.vue'),
		meta: {
			title: 'Afgeronde opnames',
			requiresAuth: true,
		}
	},
];